export const navLinks = [
  { id: 'overview', label: '站点概览' },
  { id: 'mobile', label: '手机版' },
  { id: 'desktop', label: '电脑版 / 网页版' },
  { id: 'app', label: 'APP 下载' },
  { id: 'guide', label: '观看指引' },
  { id: 'films', label: '影片导览' },
  { id: 'faq', label: '常见问题' },
  { id: 'notice', label: '使用须知' },
];

export const heroCards = [
  {
    id: 'mobile',
    icon: 'ri-smartphone-line',
    title: '秋霞影院手机版',
    desc: '面向手机屏幕重新排布，竖屏单手可操作，适配移动网络。',
    tag: '移动优先',
  },
  {
    id: 'desktop',
    icon: 'ri-computer-line',
    title: '电脑版 / 网页版',
    desc: '电脑端信息密度更高，网页版无需安装，打开即用。',
    tag: '大屏浏览',
  },
  {
    id: 'app',
    icon: 'ri-download-2-line',
    title: 'APP 下载说明',
    desc: '了解客户端下载前需要确认的版本、来源与安全事项。',
    tag: '客户端',
  },
  {
    id: 'guide',
    icon: 'ri-compass-3-line',
    title: '浏览器观看与在线看',
    desc: '不装应用也能看，梳理手机浏览器观看与在线看的基本流程。',
    tag: '免安装',
  },
];

export const overviewStats = [
  { value: '4 种', label: '访问终端形态', desc: '手机、电脑、网页与客户端' },
  { value: '7 大', label: '内容分类方向', desc: '剧情 / 悬疑 / 喜剧 等' },
  { value: '8 条', label: '常见问题解答', desc: '访问前的高频疑问' },
  { value: '1 页', label: '集中式速查', desc: '所有说明收在本页' },
];

export const overviewNotes = [
  {
    icon: 'ri-file-list-3-line',
    title: '本站说明什么',
    desc: '集中介绍秋霞影院在线观看所涉及的手机版、电脑版、网页版与 APP 下载等访问方式，并延伸到手机浏览器观看与手机在线看的相关内容。',
  },
  {
    icon: 'ri-question-answer-line',
    title: '适合谁看',
    desc: '适合第一次接触、想先弄清楚“该用哪种方式打开”的普通用户，也适合想快速比对各端差异、找到顺手方案的老用户。',
  },
  {
    icon: 'ri-information-line',
    title: '内容尺度说明',
    desc: '页面以整理与科普为主，涉及具体版本、来源与地址时给出通用判断方法，不在本页提供任何下载或播放跳转。',
  },
];

export const mobileFeatures = [
  {
    icon: 'ri-layout-line',
    title: '竖屏优先的排版',
    desc: '手机版把导航收敛为底部或抽屉式入口，内容卡片单列纵向排布，减少左右滑动与横向溢出。',
  },
  {
    icon: 'ri-hand-heart-line',
    title: '单手可触控',
    desc: '主要按钮与分类标签下移到拇指可及的区域，点击目标更大，误触概率更低。',
  },
  {
    icon: 'ri-signal-tower-line',
    title: '省流与弱网适配',
    desc: '弱网环境下一般会先加载文字与封面缩略图，清晰度与画质可按网络情况自行调整。',
  },
  {
    icon: 'ri-history-line',
    title: '观看记录与续看',
    desc: '登录后通常可保留播放进度与浏览记录，方便在手机上接着上次的位置继续。',
  },
  {
    icon: 'ri-fullscreen-line',
    title: '横屏播放体验',
    desc: '播放页支持旋转横屏、锁屏与亮度音量手势，全屏后可隐藏多余控件。',
  },
  {
    icon: 'ri-folder-shield-2-line',
    title: '权限更克制',
    desc: '手机版本通常只申请网络与存储等必要权限，安装前应留意权限清单是否合理。',
  },
];

export const versionCompare = [
  { item: '打开方式', mobile: '手机浏览器或客户端', desktop: '电脑浏览器或客户端', web: '任意浏览器直接访问' },
  { item: '是否需要安装', mobile: '可选，浏览免安装', desktop: '可选，浏览免安装', web: '完全不需要安装' },
  { item: '最佳屏幕', mobile: '5–7 英寸竖屏', desktop: '13 英寸以上横屏', web: '任意尺寸，自适应' },
  { item: '信息密度', mobile: '中，单列卡片为主', desktop: '高，多列网格为主', web: '随窗口宽度变化' },
  { item: '典型场景', mobile: '通勤、睡前碎片时间', desktop: '居家、长时间观看', web: '临时借用设备、快速查看' },
  { item: '使用门槛', mobile: '低', desktop: '低', web: '最低，免安装' },
];

export const appNotes = [
  {
    icon: 'ri-shield-check-line',
    title: '来源要能追溯',
    desc: '下载客户端前先确认来源页面是否稳定、是否有明确的主体说明，来源模糊的安装包不建议安装。',
  },
  {
    icon: 'ri-cpu-line',
    title: '先看系统版本',
    desc: '安装前核对系统版本与处理器架构是否匹配，版本过旧通常会被提示“无法安装”或直接闪退。',
  },
  {
    icon: 'ri-file-shield-2-line',
    title: '留意权限申请',
    desc: '一个影音客户端通常不需要通讯录、短信等权限，出现无关的高危权限应谨慎授权。',
  },
  {
    icon: 'ri-refresh-line',
    title: '保持版本更新',
    desc: '客户端版本过旧可能无法正常加载内容，建议在来源可靠的前提下定期更新到较新版本。',
  },
  {
    icon: 'ri-delete-bin-6-line',
    title: '卸载要清干净',
    desc: '卸载后部分缓存与登录状态可能仍留在本地，介意隐私的用户可手动清理残留数据。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '异常先排查',
    desc: '遇到打不开、白屏等情况，先尝试切换网络、清理缓存或更换浏览器，再判断是否为客户端问题。',
  },
];

export const browserSteps = [
  {
    step: '01',
    title: '用浏览器打开入口',
    desc: '在手机自带浏览器或第三方浏览器地址栏输入入口地址，建议手动输入或使用书签，避免点击来源不明的短链。',
  },
  {
    step: '02',
    title: '按竖屏结构浏览',
    desc: '页面会以单列卡片呈现分类与条目，顶部通常是搜索或分类标签，向下滑动即可逐段浏览内容。',
  },
  {
    step: '03',
    title: '选择分类或搜索',
    desc: '通过分类标签缩小范围，或用搜索框输入片名关键词，结果会在本页内展示，无需跳转其它应用。',
  },
  {
    step: '04',
    title: '进入播放并按需全屏',
    desc: '点选条目进入播放页，旋转手机即可横屏观看；如提示加载缓慢，可先降低清晰度再重试。',
  },
];

export const onlineWatchFeatures = [
  {
    icon: 'ri-live-line',
    title: '无需下载即点即看',
    desc: '在线看模式依托浏览器直接播放，省去安装步骤，适合临时使用或设备存储空间有限的用户。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '清晰度可自主切换',
    desc: '一般提供多档清晰度选项，网络波动时可手动降档以换取更流畅的播放体验。',
  },
  {
    icon: 'ri-mail-download-line',
    title: '缓存与离线考虑',
    desc: '部分内容可能支持缓存到本地，是否可用取决于具体来源与内容，需留意存储空间占用。',
  },
  {
    icon: 'ri-earth-line',
    title: '跨设备更灵活',
    desc: '同一入口在不同设备上呈现一致内容，换设备时只需重新打开页面，无需重复配置。',
  },
];

export const filmCategories = ['全部', '剧情', '悬疑', '喜剧', '科幻', '家庭', '纪录'];

export const filmItems = [
  {
    title: '黄昏列车',
    category: '剧情',
    meta: '剧情 · 旅途 · 长片',
    desc: '一趟穿行在黄昏里的旧式列车，串起几位陌生旅客各自未说出口的心事。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20movie%20poster%20art%20of%20a%20vintage%20train%20at%20golden%20sunset%20crossing%20open%20plains%2C%20warm%20amber%20and%20deep%20red%20color%20palette%2C%20painterly%20flat%20illustration%20with%20grain%20texture%2C%20no%20text%2C%20simple%20gradient%20background%2C%20editorial%20poster%20composition&width=600&height=800&seq=qx-film-01&orientation=portrait',
  },
  {
    title: '山城旧事',
    category: '剧情',
    meta: '剧情 · 时代 · 长片',
    desc: '一座依山而建的小城，几代人的生活随着街巷的改造慢慢发生改变。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20movie%20poster%20art%20of%20a%20mountain%20town%20with%20stacked%20old%20houses%20in%20misty%20morning%20light%2C%20muted%20terracotta%20and%20olive%20tones%2C%20painterly%20flat%20illustration%20with%20grain%20texture%2C%20no%20text%2C%20simple%20gradient%20background%2C%20editorial%20poster%20composition&width=600&height=800&seq=qx-film-02&orientation=portrait',
  },
  {
    title: '深海回声',
    category: '悬疑',
    meta: '悬疑 · 海洋 · 长片',
    desc: '一支海洋勘探队在深海记录到异常信号，随之揭开一段被刻意隐藏的往事。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20movie%20poster%20art%20of%20a%20deep%20ocean%20trench%20with%20a%20faint%20sonar%20glow%20in%20dark%20water%2C%20deep%20teal%20and%20charcoal%20with%20amber%20highlight%2C%20painterly%20flat%20illustration%20with%20grain%20texture%2C%20no%20text%2C%20simple%20gradient%20background%2C%20editorial%20poster%20composition&width=600&height=800&seq=qx-film-03&orientation=portrait',
  },
  {
    title: '雾中访客',
    category: '悬疑',
    meta: '悬疑 · 小镇 · 短剧',
    desc: '一个名字被反复提及却从未露面的人，让小镇上每个人的叙述都出现了偏差。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20movie%20poster%20art%20of%20a%20lonely%20silhouette%20walking%20under%20a%20street%20lamp%20in%20thick%20fog%2C%20muted%20indigo%20grey%20and%20warm%20lamp%20glow%2C%20painterly%20flat%20illustration%20with%20grain%20texture%2C%20no%20text%2C%20simple%20gradient%20background%2C%20editorial%20poster%20composition&width=600&height=800&seq=qx-film-04&orientation=portrait',
  },
  {
    title: '街角理发店',
    category: '喜剧',
    meta: '喜剧 · 市井 · 短剧',
    desc: '一家开了三十年的理发店，靠着一群老顾客的日常琐事撑起了全年笑点。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20movie%20poster%20art%20of%20a%20cozy%20small%20barbershop%20corner%20with%20warm%20interior%20light%2C%20retro%20cream%20and%20rust%20orange%20palette%2C%20painterly%20flat%20illustration%20with%20grain%20texture%2C%20no%20text%2C%20simple%20gradient%20background%2C%20editorial%20poster%20composition&width=600&height=800&seq=qx-film-05&orientation=portrait',
  },
  {
    title: '第七个夏天',
    category: '家庭',
    meta: '家庭 · 成长 · 长片',
    desc: '一家人在第七个夏天回到海边老屋，重新面对那些被搁置多年的选择。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20movie%20poster%20art%20of%20a%20seaside%20old%20house%20with%20open%20windows%20in%20summer%20breeze%2C%20soft%20sand%20beige%20and%20sky%20blue%20accents%20but%20warm%20overall%2C%20painterly%20flat%20illustration%20with%20grain%20texture%2C%20no%20text%2C%20simple%20gradient%20background%2C%20editorial%20poster%20composition&width=600&height=800&seq=qx-film-06&orientation=portrait',
  },
  {
    title: '夜航星图',
    category: '科幻',
    meta: '科幻 · 星际 · 长片',
    desc: '一艘驶向深空的补给船，用一张不断更新的星图记录着人类远行的坐标。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20movie%20poster%20art%20of%20a%20lone%20cargo%20spaceship%20sailing%20past%20a%20glowing%20star%20chart%20nebula%2C%20deep%20plum%20and%20gold%20highlights%2C%20painterly%20flat%20illustration%20with%20grain%20texture%2C%20no%20text%2C%20simple%20gradient%20background%2C%20editorial%20poster%20composition&width=600&height=800&seq=qx-film-07&orientation=portrait',
  },
  {
    title: '风起南巷',
    category: '剧情',
    meta: '剧情 · 青春 · 短剧',
    desc: '南方巷弄里的几个年轻人，在离开与留下之间各自做出了不同的决定。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20movie%20poster%20art%20of%20a%20narrow%20southern%20alley%20with%20green%20vines%20and%20dappled%20sunlight%2C%20fresh%20green%20and%20warm%20cream%20palette%2C%20painterly%20flat%20illustration%20with%20grain%20texture%2C%20no%20text%2C%20simple%20gradient%20background%2C%20editorial%20poster%20composition&width=600&height=800&seq=qx-film-08&orientation=portrait',
  },
  {
    title: '候鸟迁徙季',
    category: '纪录',
    meta: '纪录 · 自然 · 系列',
    desc: '跟随候鸟跨越大陆与海岸线，记录它们年复一年、几乎不发生偏差的旅程。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20documentary%20poster%20art%20of%20migrating%20birds%20flying%20over%20golden%20marshes%20at%20dawn%2C%20warm%20ocher%20and%20moss%20green%20palette%2C%20painterly%20flat%20illustration%20with%20grain%20texture%2C%20no%20text%2C%20simple%20gradient%20background%2C%20editorial%20poster%20composition&width=600&height=800&seq=qx-film-09&orientation=portrait',
  },
];

export const faqItems = [
  {
    q: '秋霞影院在线观看和手机版有什么区别？',
    a: '“在线观看”强调的是不用下载、打开即看的使用方式；“手机版”强调的是为手机屏幕和触控优化的呈现形态。两者可以同时成立：用手机浏览器打开即是在线观看，而页面结构针对手机做了适配，就是手机版。',
  },
  {
    q: '不安装 APP 能用吗？',
    a: '可以。网页版与手机浏览器观看都不需要安装任何客户端，只要浏览器能正常联网即可访问。客户端更多是提供更稳定的入口与部分本地化功能，并非必选项。',
  },
  {
    q: '手机浏览器观看时页面显示不全怎么办？',
    a: '先确认浏览器是否开启了桌面站点模式，可切换回移动模式；其次清理一下浏览器缓存并刷新。若仍异常，可尝试更换浏览器或检查系统字体缩放设置是否过大。',
  },
  {
    q: '电脑版和网页版是一回事吗？',
    a: '不完全是。网页版泛指用浏览器访问的形态；电脑版通常指针对电脑大屏横屏布局做过优化的版本。用电脑浏览器打开网页版时，往往就会呈现接近电脑版的多列布局。',
  },
  {
    q: '下载客户端前要注意什么？',
    a: '重点看三点：来源是否稳定可追溯、系统版本是否匹配、权限申请是否合理。来源模糊、要求无关高危权限、或安装包体积异常偏小的，都建议先核实再决定。',
  },
  {
    q: '在线看时一直缓冲怎么处理？',
    a: '先切换网络（例如从移动数据切到 Wi-Fi，或反之），再尝试降低播放清晰度；也可以在观看设置中关闭自动最高画质。若是高峰期卡顿，稍后重试通常能缓解。',
  },
  {
    q: '手机上能横屏全屏观看吗？',
    a: '大多数手机浏览器的播放器都支持横屏全屏。若无法自动旋转，先检查系统是否开启了方向锁定，或查看播放器内是否有全屏按钮。',
  },
  {
    q: '观看记录会保存吗？',
    a: '是否保存取决于具体站点与是否登录。一般来说，登录状态下的进度记录更可能被保留；未登录或清理过浏览器数据后，本地记录可能随之丢失。',
  },
];

export const noticeItems = [
  {
    icon: 'ri-scales-3-line',
    title: '内容版权提示',
    desc: '本站为信息整理页面，不提供音视频内容本身。请在合法合规、且来源清楚的前提下使用相关服务。',
  },
  {
    icon: 'ri-eye-off-line',
    title: '谨慎对待陌生链接',
    desc: '避免点击来源不明的短链、群聊转发链接或诱导下载页面，这类链接常伴随跳转与捆绑风险。',
  },
  {
    icon: 'ri-lock-2-line',
    title: '保护个人信息',
    desc: '在未确认来源可靠前，不要随意填写手机号、验证码或支付信息；正规站点一般不会索要无关隐私。',
  },
  {
    icon: 'ri-device-line',
    title: '设备与账号安全',
    desc: '建议保持系统与浏览器为较新版本，安装可靠的安全软件，并避免在多个平台使用同一密码。',
  },
];